import React from 'react';

interface OnChainIconProps {
	className?: string;
	size?: 'small' | 'medium' | 'large';
}

const OnChainIcon = ({ className, size = 'large', ...props }: OnChainIconProps) => (
	<svg
		{...props}
		width={size === 'small' ? '16' : size === 'medium' ? '20' : '24'}
		height={size === 'small' ? '16' : size === 'medium' ? '20' : '24'}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		style={{
			minWidth: size === 'small' ? '16' : size === 'medium' ? '20' : '24',
			minHeight: size === 'small' ? '16' : size === 'medium' ? '20' : '24',
		}}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.70186 2.07038C7.88954 1.97654 8.11046 1.97654 8.29814 2.07038L13.5393 4.69098C13.8217 4.83214 14 5.1207 14 5.43634V10.5637C14 10.8793 13.8217 11.1679 13.5393 11.309L8.52175 13.8178C8.1933 13.982 7.8067 13.982 7.47825 13.8178L2.46066 11.309C2.17834 11.1679 2 10.8793 2 10.5637V5.43634C2 5.1207 2.17833 4.83214 2.46066 4.69098L7.70186 2.07038ZM4.83333 9.02432V6.97568L3.33333 6.22568V9.77432L4.83333 9.02432ZM5.83333 9.02432L7.5 9.85765V8.30902L5.83333 7.47568V9.02432ZM5.33333 9.89235L3.97104 10.5735L7.5 12.338V10.9757L5.33333 9.89235ZM3.97104 5.4265L5.33333 6.10765L7.77639 4.88612C7.91716 4.81574 8.08284 4.81574 8.22361 4.88612L10.6667 6.10765L12.029 5.4265L8 3.41202L3.97104 5.4265ZM12.6667 6.22568L11.1667 6.97568V9.02432L12.6667 9.77432V6.22568ZM8.5 8.30902L10.1667 7.47568V9.02432L8.5 9.85765V8.30902ZM8.5 10.9757L10.6667 9.89235L12.029 10.5735L8.5 12.338V10.9757ZM9.54863 6.66667L8 5.89235L6.45137 6.66667L8 7.44098L9.54863 6.66667Z"
			fill="currentColor"
		/>
	</svg>
)

export default OnChainIcon 